const IS_PREVIEW = process.env.REACT_APP_BACKEND_URL?.includes('preview');
const VERSION_NUMBER = '1.001';
export const APP_VERSION = IS_PREVIEW ? `test.v.${VERSION_NUMBER}` : `pub.v.${VERSION_NUMBER}`;
